/**
 * Soharie prototype scroll-reveal — IntersectionObserver for custom-* sections.
 * Matches prototype threshold: 0.12
 */
(function () {
  const SELECTOR = '.ccs-reveal, .ccs-stagger-card';
  const THRESHOLD = 0.12;
  let observer;

  function observeElements(root) {
    if (!observer) return;
    const scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.classList.contains('ccs-visible')) {
        observer.observe(el);
      }
    });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('ccs-visible');
      });
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ccs-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD }
    );

    observeElements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeElements(event.target);
  });
})();
